import React from 'react'
import ociTraining from '../../assets/images/oci-training.png'
import './OCI.css'
import {ExternalLink} from "../helpers/EasyLinks";

const OCITraining = () => (
    <div className="oci">
        <p className="lead">Add to the experience.</p>
        <p><ExternalLink link="https://objectcomputing.com/training/catalog/groovy-programming/groovy-training-2018-gr8-eu"> <img src={ociTraining} alt="Groovy training by OCI"/></ExternalLink></p>
    </div>
);

export default OCITraining;


// WEBPACK FOOTER //
// ./src/components/prices/OCI.js